import { Routes } from '@angular/router';
import { LandingPageComponent } from './pages/home/landing-page/landing-page.component';

export const routes: Routes = [
  {
    path: '',
    component: LandingPageComponent
  },
  {
    path: '',
    loadChildren: () => import('./pages/authentication/authentication.module').then((m) => m.AuthenticationModule)
  },
  {
    path: '',
    loadChildren: () => import('./pages/errors/errors.module').then((m) => m.ErrorsModule)
  },
  {
    path: '',
    loadChildren: () => import('./pages/home/home.module').then((m) => m.HomeModule)
  },
  { path: '**', redirectTo: '/404' }
];
